
<template>
  <div class="home flex_row apphome">
    <appleft class="app5760 flex_column" />

    <div class="left flex_column">
      <div class="mybox">
        <div class="title">能源走势</div>
        <div class="box" style="overflow: visible">
          <EnergyTrend></EnergyTrend>
        </div>
      </div>
      <div class="mybox">
        <div class="title">能源结构</div>
        <div class="box">
          <EnergyStructure></EnergyStructure>
        </div>
      </div>
      <div class="mybox">
        <div class="title">设备状态</div>
        <div class="box">
          <DeviceStatus></DeviceStatus>
        </div>
      </div>
      <div class="mybox">
        <div class="title">重点用能设备</div>
        <div class="box">
          <KeyEnergyEquipment></KeyEnergyEquipment>
        </div>
      </div>
    </div>
    <div class="center flex_column">
      <div class="top">
        <div class="mybox">
          <div class="box">
            <img width="100%" height="100%" :src="qyxx.imgUrl" alt="企业形像">
          </div>
        </div>
      </div>
      <div class="bottom flex_row">
        <div class="flex_column">
          <div class="mybox">
            <div class="title">全年碳排放指标</div>
            <div class="box">
              <CarbonEmission></CarbonEmission>
            </div>
          </div>
          <div class="mybox">
            <div class="title">能源优化投入</div>
            <div class="box">
              <EnergyInvestment></EnergyInvestment>
            </div>
          </div>
        </div>
        <div class="flex_column">
          <div class="mybox">
            <div class="title">减排进度及走势</div>
            <div class="box">
              <EmissionReduction></EmissionReduction>
            </div>
          </div>
          <div class="mybox">
            <div class="title">能源优化成效</div>
            <div class="box">
              <EnergyResults></EnergyResults>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right flex_column">
      <div class="mybox">
        <div class="title">能源指标</div>
        <div class="box">
          <EnergyIndex></EnergyIndex>
        </div>
      </div>
      <div class="mybox">
        <div class="title">行业对标</div>
        <div class="box">
          <IndustryBenchmarking></IndustryBenchmarking>
        </div>
      </div>
      <div class="mybox">
        <div class="title">能源损耗</div>
        <div class="box">
          <EnergyConsumption></EnergyConsumption>
        </div>
      </div>
      <div class="mybox">
        <div class="title">投产比</div>
        <div class="box">
          <ProductionRatio></ProductionRatio>
        </div>
      </div>
    </div>

    <appright  class="app5760 flex_column"/>
  </div>
</template>

<script>
import api from '@/apis/home'
import EnergyTrend from "@/components/EnergyTrend";//能源走势
import EnergyStructure from "@/components/EnergyStructure";//能源结构
import DeviceStatus from "@/components/DeviceStatus";//设备状态
import KeyEnergyEquipment from "@/components/KeyEnergyEquipment";//重点用能设备
import EnergyInvestment from "@/components/EnergyInvestment";//能源优化投入
import EnergyResults from "@/components/EnergyResults";//能源优化成效
import EmissionReduction from "@/components/EmissionReduction";//减排进度及走势
import CarbonEmission from "@/components/CarbonEmission";//全年碳排放指标
import ProductionRatio from "@/components/ProductionRatio";//投产比
import IndustryBenchmarking from "@/components/IndustryBenchmarking";//行业对标
import EnergyIndex from "@/components/EnergyIndex";//能源指标
import EnergyConsumption from "@/components/EnergyConsumption";//能源损耗

import appleft from "@/components/appleft";
import appright from "@/components/appright";

export default {
  components: {
    appleft,
    appright,

    EnergyTrend,
    EnergyStructure,
    DeviceStatus,
    KeyEnergyEquipment,
    EnergyInvestment,
    EnergyResults,
    EmissionReduction,
    CarbonEmission,
    ProductionRatio,
    IndustryBenchmarking,EnergyIndex,EnergyConsumption
  },
  data() {
    return {
      //企业形像
      qyxx: {
        imgUrl: require('@/assets/images/pic.png'),
      },


    };
  },
  methods: {},
  mounted() {

    //企业形像
    api.qyxx().then((res) => {
      if (res.code === 10000) {
        this.qyxx = res.data
      } else {
        this.$message.error(res.message)
      }
    })

  },
};
</script>

<style lang="less" scoped>
.home {
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding: 0 0.5rem 0.5rem;
  & > .left {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
  & > .center {
    height: 100%;
    overflow: hidden;
    width: 50%;
    & > .top,
    & > .bottom {
      height: 50%;
      overflow: hidden;
    }
    & > .top {
      padding-bottom: 0.6em;
      .mybox {
        flex: 1;
        height: 100%;
        overflow: hidden;
      }
    }
    & > .bottom {
      & > .flex_column {
        width: 50%;
        height: 100%;
        overflow: hidden;
        .mybox {
          flex: 1;
          height: 50%;
          overflow: hidden;
        }
      }
    }
  }
  & > .right {
    height: 100%;
    overflow: hidden;
    width: 25%;
    .mybox {
      flex: 1;
      height: 25%;
      overflow: hidden;
    }
  }
}
</style>
